import { Component, computed, DestroyRef, effect, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { type LayoutDto } from '@api/devices';
import { APPLICATION_TYPE, EntityStatus } from '@core';
import { Store } from '@ngrx/store';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { filter } from 'rxjs';

import { type ChildRelationDevices, PortLayout } from '../../models';
import { SwitchPortTypes } from '../../models';
import { DevicesSelectors } from '../../ngrx-store';
import { getPortRows } from './layout.helper';

@Component({
  imports: [
    NgxSkeletonLoaderModule,
  ],
  selector: 'avs-li-port-plan',
  standalone: true,
  styleUrl: './port-plan.component.scss',
  templateUrl: './port-plan.component.html',
})
export class PortPlanComponent {
  deviceId = input.required<string>();
  layout = input<LayoutDto | undefined>();
  portList = signal<ChildRelationDevices[] | null>(null);
  selectedPortId = input<string | null>();
  selectedPort = output<ChildRelationDevices | null>();
  portRows = computed(() => getPortRows(this.portList() || [], this.layout()));
  protected appType = inject(APPLICATION_TYPE);
  protected readonly eEntityStatus = EntityStatus;
  protected readonly eSwitchPortTypes = SwitchPortTypes;
  protected readonly ePortLayout = PortLayout;
  protected readonly Math = Math;
  private store = inject(Store);
  private destroyRef = inject(DestroyRef);

  constructor() {
    effect(() => {
      this.store.select(DevicesSelectors.getDeviceById(this.deviceId()))
        .pipe(
          filter(Boolean),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe(device => {
          this.portList.set(device.portDevices || null);
        });
    });
  }
}
